var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 18,
    fill: "#D3EFEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 20h19v30H25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.896 17.5V17h-6.771C23.432 17 22 18.375 22 20v30c0 1.688 1.432 3 3.125 3h6.77v-.5c0-1.375 1.173-2.5 2.605-2.5 1.497 0 2.604 1.125 2.604 2.5v.5h6.771C45.633 53 47 51.687 47 50V20c0-1.625-1.367-3-3.125-3h-6.77v.5c0 1.438-1.108 2.5-2.605 2.5-1.432 0-2.604-1.063-2.604-2.5ZM29.422 20c.976 1.813 2.864 3 5.078 3 2.279 0 4.167-1.188 5.143-3h4.232v30h-4.232a5.854 5.854 0 0 0-5.143-3c-2.214 0-4.102 1.25-5.078 3h-4.297V20h4.297Z",
    fill: "#5CC8B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 30.5,
    r: 1.5,
    fill: "#5CC8B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 30.5,
    r: 1.5,
    fill: "#5CC8B3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 30.5,
    r: 1.5,
    fill: "#5CC8B3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 30.5,
    r: 1.5,
    fill: "#5CC8B3"
  })));
};

export default SvgOrders;